module.exports = __webpack_public_path__ + "img/coteBrest-header.010d54f7.jpg";